export const HOST_NAME = 'https://anifty.jp';
